import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EMPTY, map, Observable } from 'rxjs';
import { LicenseDependentButtonModel } from '../../models/license-dependent-button.model';
import { LicenseResultModel } from '../../models/license.result.model';
import { PaymentType } from '../../models/payment-type.enum';
import { LanguageService } from '../../services/language.service';
import { LicenseService } from '../../services/license.service';

@Component({
  selector: 'hazmatsuite-next-license-dependent-button',
  templateUrl: './license-dependent-button.component.html',
  styleUrls: ['./license-dependent-button.component.scss'],
})
export class LicenseDependentButtonComponent implements OnInit {
  @Input() skipCache = false;
  @Input() set model(m: LicenseDependentButtonModel) {
    this.buttonModel = m;
  }
  @Input() title = '';
  @Output() submitAction = new EventEmitter<void>;
  @Output() beforeNavigationAction = new EventEmitter<void>;

  private baseUrl = `${window.location.origin}/${this.languageService.getLanguage()}/Account/Authentication`;


  licenseResult$: Observable<LicenseResultModel> = EMPTY;
  routeLanguage = 'de';
  paymentTypes: typeof PaymentType = PaymentType;
  showLoginModal = false;
  showRequiredLicenseModal = false;
  showCreditsModal = false;
  buttonModel: LicenseDependentButtonModel = new LicenseDependentButtonModel();
  loginUrl = `${this.baseUrl}/Login?returnUrl=${encodeURIComponent(window.location.href)}`;
  registerUrl = `${this.baseUrl}/Register?returnUrl=${encodeURIComponent(window.location.href)}`;
  subscriptionUrl = `${window.location.origin}/${this.languageService.getLanguage()}/Account/Subscriptions`;

  layoutTranslations$ = this.languageService.translations$.pipe(
    map(data => data['LayoutResource'])
  );
  paymentTranslations$ = this.languageService.translations$.pipe(
    map(data => data['PaymentResources'])
  );

  constructor(private licenseService: LicenseService, private languageService: LanguageService) {
    this.languageService.fetchResources(['LayoutResource', 'PaymentResources']);
  }

  ngOnInit(): void {
    this.routeLanguage = this.languageService.getLanguage();
    this.licenseResult$ = this.licenseService.checkLicense(this.buttonModel, this.skipCache);

  }

  callback(): void {
    this.submitAction.emit();
  }
}
